import React, { useState } from "react";
import { Modal } from "antd";
import confirmBox from "../../CoreComponents/confirmBox";

export default function MergeDialog({ umbrella, others, onMerge, onClose }) {
  const [keepId, setKeepId] = useState("");
  const keep = others.find((row) => String(row.id) === keepId);
  const ask = () =>
    confirmBox({
      title: `Merge ${umbrella.name} into ${keep.name}?`,
      message: `Every menu category under ${umbrella.name} moves to ${keep.name}, and typing "${umbrella.name}" will find ${keep.name} from now on.`,
      yesLabel: "Merge",
      noLabel: "Cancel",
      onYes: () => onMerge(keep.id),
    });
  return (
    <Modal open title={`Merge ${umbrella.name}`} onCancel={onClose} footer={null} destroyOnClose>
      <label className="umb-label" htmlFor="umb-keep">Keep</label>
      <select id="umb-keep" className="form-control" value={keepId} onChange={(event) => setKeepId(event.target.value)}>
        <option value="">Pick the category that stays</option>
        {others.map((row) => (
          <option key={row.id} value={row.id}>{row.name}</option>
        ))}
      </select>
      <div className="umb-dialog-buttons">
        <button type="button" className="btn btn-light" onClick={onClose}>Cancel</button>
        <button type="button" className="btn btn-primary" disabled={!keep} onClick={ask}>
          {keep ? `Merge into ${keep.name}` : "Merge"}
        </button>
      </div>
    </Modal>
  );
}
